module.exports = __webpack_public_path__ + "img/ment.26ddf838.jpg";